import axios from "./api"

const featuresApi = {
    getFeatures(data) {
        return axios.get(`/api/features`, data);
    },
    postNetPromoterScore(data) {
        return axios.post(`/api/features/nps`, data);
    }
}

export default featuresApi;
